import { urlReplace } from "helpers/url";
import Api from "./Api";

export default class ProtocolService {
	constructor(api) {
		this.api = api || new Api();
	}

	async getAll(params) {
		return this.api.get('/secure/protocols', params);
	}

	async getById(id, params) {
		return this.api.get(urlReplace('/secure/protocol/{id}', { id: id }), params);
	}
}


